module.exports = __webpack_public_path__ + "static/media/squared.8bac15d2.jpg";